<template>
  <v-dialog v-model="dialog" max-width="1200" persistent>
    <v-card>
      <v-container class="px-8 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">
          Process Due PDCs ({{ duePdcs.length }})
        </p>
        <v-simple-table v-if="!mobile" fixed-header height="400" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Cleared</th>
                <th class="text-left">Status</th>
                <th class="text-left">Unit Name</th>
                <th class="text-left">Tenant</th>
                <th class="text-left">Check No.</th>
                <th class="text-left">Check Date</th>
                <th class="text-left">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pdc, index) in duePdcsWithData" :key="index">
                <td>
                  <v-checkbox
                    v-model="pdc.cleared"
                    hide-details
                    dense
                    class="mt-0"
                    @change="changeCleared(index)"
                  ></v-checkbox>
                </td>
                <td style="width: 15%">
                  <v-select
                    v-model="pdc.status"
                    :items="pdcStatuses"
                    hide-details
                    dense
                    outlined
                    :disabled="pdc.cleared"
                  >
                    <template v-slot:selection="{ item }">
                      <p v-if="pdc.cleared" class="grey--text caption">
                        {{ item.text }}
                      </p>
                      <p v-else class="caption">{{ item.text }}</p>
                    </template>
                    <template v-slot:item="{ item }">
                      <p class="caption">{{ item.text }}</p>
                    </template>
                  </v-select>
                </td>
                <td style="width: 20%">
                  <p class="caption">{{ pdc.bedName }}</p>
                </td>
                <td style="width: 20%">
                  <p class="caption">{{ pdc.tenantName }}</p>
                </td>
                <td style="width: 20%">
                  <p class="caption">{{ pdc.checkNumber }}</p>
                </td>
                <td style="width: 15%">
                  <p class="caption">{{ pdc.dueDate }}</p>
                </td>
                <td>
                  <p class="caption">{{ formatCurrency(pdc.amount) }}</p>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table v-else>
          <v-divider></v-divider>
          <div v-for="(pdc, index) in duePdcsWithData" :key="index">
            <tr class="d-flex flex-grow-1">
              <div class="d-flex flex-grow-1 flex-column py-2">
                <div class="d-flex flex-row">
                  <v-col class="pa-0">
                    <p class="font-weight-bold body-2">{{ pdc.tenantName }}</p>
                  </v-col>
                  <v-col class="pa-0" align="end">
                    <p class="font-weight-bold body-2">
                      {{ formatCurrency(pdc.amount) }}
                    </p>
                  </v-col>
                </div>
                <div class="d-flex flex-row">
                  <v-col class="pa-0 caption font-weight-bold">
                    CHECK DATE
                  </v-col>
                  <v-col class="pa-0" align="end">
                    <p class="caption">{{ pdc.dueDate }}</p>
                  </v-col>
                </div>
                <div class="d-flex flex-row">
                  <v-col class="pa-0 caption"> Check No. </v-col>
                  <v-col class="pa-0 caption" align="end">
                    {{ pdc.checkNumber }}
                  </v-col>
                </div>
                <div class="d-flex flex-row my-1">
                  <v-col class="pa-0 caption d-flex align-center">
                    Cleared
                  </v-col>
                  <v-col class="pa-0" align="end">
                    <v-simple-checkbox
                      v-model="pdc.cleared"
                      color="primary"
                      :ripple="false"
                      dense
                      class="mt-0"
                      @input="changeCleared(index)"
                    ></v-simple-checkbox>
                  </v-col>
                </div>
                <div class="d-flex flex-row mt-1">
                  <v-col class="pa-0 caption d-flex align-center">
                    Status
                  </v-col>
                  <v-col class="pa-0" cols="8">
                    <v-select
                      v-model="pdc.status"
                      :items="pdcStatuses"
                      hide-details
                      dense
                      outlined
                      :disabled="pdc.cleared"
                    >
                      <template v-slot:selection="{ item }">
                        <p v-if="pdc.cleared" class="grey--text caption">
                          {{ item.text }}
                        </p>
                        <p v-else class="caption">{{ item.text }}</p>
                      </template>
                      <template v-slot:item="{ item }">
                        <p class="caption">{{ item.text }}</p>
                      </template>
                    </v-select>
                  </v-col>
                </div>
              </div>
            </tr>
            <v-divider></v-divider>
          </div>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      duePdcsWithData: [],
      pdcStatuses: [
        { text: 'Open', value: 'open' },
        { text: 'Processed', value: 'processed' },
        { text: 'Not Cleared', value: 'not_cleared' },
        { text: 'Cleared', value: 'cleared', disabled: true }
      ]
    }
  },
  computed: {
    duePdcs() {
      return this.$store.getters['pdcs/getDuePdcs']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    async open() {
      await this.$store.dispatch('pdcs/fetchDuePdcsAction')
      this.$store.state.pdcs.openProcess = false
      this.dialog = true
      this.duePdcsWithData = JSON.parse(
        JSON.stringify(
          this.duePdcs
            .map((d) => {
              d.cleared = false
              d.status = 'open'
              d.amount = d.payment_details && d.payment_details.total
              return d
            })
            .sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate))
        )
      )
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      if (
        await this.$root.$confirm({
          title: 'Process PDCs',
          message:
            'Are you sure you would like to update the post dated checks?'
        })
      ) {
        this.$root.$setLoading(true)
        for (let index in this.duePdcsWithData) {
          const entry = this.duePdcsWithData[index]
          if (entry.cleared) {
            await this.$store.dispatch('pdcs/setClearedAction', {
              pdcId: entry.pdcId
            })
          } else if (entry.status === 'processed') {
            await this.$store.dispatch('pdcs/setProcessedAction', {
              pdcId: entry.pdcId
            })
          } else if (entry.status === 'not_cleared') {
            await this.$store.dispatch('pdcs/setNotClearedAction', {
              pdcId: entry.pdcId
            })
          } else if (entry.status === 'open') {
            await this.$store.dispatch('pdcs/setOpenAction', {
              pdcId: entry.pdcId
            })
          }
        }
        await this.$root
          .$confirm({
            title: 'Process PDCs',
            message: `The post dated checks have been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'success'
            }
          })
          .then(() => {
            this.$root.$setLoading(false)
            this.dialog = false
            this.resolve(true)
          })
      }
    },
    cancel() {
      this.dialog = false
    },
    changeCleared(index) {
      if (this.duePdcsWithData[index].cleared) {
        this.duePdcsWithData[index].status = 'cleared'
      } else {
        this.duePdcsWithData[index].status = 'open'
      }
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    }
  }
}
</script>

<style scoped>
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
</style>
